import { Button, Container, Group, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { replace, useNavigate } from 'react-router';
import styles from './ErrorPage.module.css';

const ShieldsErrorPage = () => {
  const { t } = useTranslation( 'error' );
  return (
    <Container className={styles.root}>
      <div className={styles.label}>Oops...</div>
      <Title className={styles.title}>{t( 'shields_error_page_title','Protección de privacidad activada' )}</Title>
      <Text c="dimmed" size="lg" ta="center" className={styles.description}>
         {t( 'shields_error_page_message_1',
          'Parece que tu navegador está bloqueando conexiones necesarias para el sitio (WebSockets, rastreadores, etc.).' )}
      </Text>
      <Text c="dimmed" size="md" ta="center" className={styles.description}>
        {t( 'shields_error_page_message_2',
          'Por favor, desactiva "Shields" o la protección de rastreo en este sitio para continuar navegando sin problemas.' )}
      </Text>

      <Group justify="center">
        <Button variant="subtle" size="md" onClick={() => window.location.reload()} >
          {t( 'reload_button', 'Reload' )}
        </Button>
      </Group>
    </Container>
  );
};

export default ShieldsErrorPage;


